import type { Entity } from './entity/index'
import type { HasWasBuiltThisTurn } from './WasBuiltThisTurn'

export function hasWasBuiltThisTurn(entity: Entity): entity is Entity & HasWasBuiltThisTurn {
  // return 'builtThisTurn' in entity
  return (entity as HasWasBuiltThisTurn).builtThisTurn === true
}
